import React from 'react';

import Header from '../../layout/Header.jsx';
import ListPics from '../../lists/ListPics.jsx';

const PagePicsList = () => (
  <div>
    <Header>Pics</Header>
    <ListPics />
  </div>
);

export default PagePicsList;
